import React from 'react';

import {IconoirServer} from '@ey-xd/motif-icon';
import NavLink from './NavLink';

export default (label, currentProjectId) => ({
	id: 5,
	key: 5,
	url: 5, // CCS TopNav component sets link.url as the key for links this is set up to supress that warning on the console
	className: 'groupRisk',
	isLink: false,
	children: (
		<NavLink
			{...{label, icon: IconoirServer, solid: false, url: `/groupriskassessment?projectId=${currentProjectId}`}}
		/>
	)
});
